export function initScrollButton() {
    // 1. Check rapido: esiste almeno un bottone di scroll?
    // Usiamo querySelector perché è più veloce di querySelectorAll e si ferma al primo match
    const hasScrollButton = document.querySelector('.scroll-down-btn');

    // 2. Se non c'è, esce subito
    if (!hasScrollButton) {
        return;
    }

    // 3. Import Dinamico
    import('./scroll_button.js')
        .then(module => {
            module.default();
        })
        .catch(err => {
            console.error('Errore nel caricamento del plugin Scroll Button:', err);
        });
}
